import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { Site } from '@iot-platform/models/i4b';
import { InfoDisplayPipe } from '@iot-platform/pipes';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  imports: [InfoDisplayPipe, TranslatePipe],
  providers: [InfoDisplayPipe],
  selector: 'iot-platform-ui-detail-card',
  templateUrl: './detail-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./detail-card.component.scss']
})
export class DetailCardComponent {
  site = input<Site>();
  extraFill = input<boolean>(false);
}
